module.exports = __webpack_public_path__ + "static/media/logo-external-retina.8bb9d5cd.png";